import React, {useState} from "react";
import {   
    Dialog,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogContent,
    Button,
    Combobox,
    Option,
    Subtitle2,
    useToastController,
} from "@fluentui/react-components";
import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import {getClientProjectTimecodeForUser} from '../../services/apiService';
import {disableExistingTimecodes} from '../../services/TimesheetDataService';
import TooltipWatcherWidget from "../TooltipWatcherWidget";
import { TOASTER_ID } from "../../services/toastUtils";
import { showErrorToast } from "../../services/toastUtils";

export default function TimeCodeSelector(props) {

    const{ startLoad, endLoad, currentWeekStart, isAddTimecodeDisabled, useStyles}= useGlobalStatus();
    const styles = useStyles();
    const [open, setOpen] = useState(false);
    const [data, setData]=useState([]);         

    const [selectedClient, setSelectedClient]=useState({clientName:"",projects:[]});
    const [selectedProject, setSelectedProject]=useState({projectName:"", budgets:[]});
    const [selectedBudget, setSelectedBudget]=useState({ budgetName:"",timecodes:[]});
    const [selectedTimecode, setSelectedTimecode]=useState({taskName:""});
    const { dispatchToast } = useToastController(TOASTER_ID);

    const openAddTimecode = async () => {
        try {
            startLoad();
    
            // Clear previous selections
            setSelectedClient({ clientName: "", projects: [] });
            setSelectedProject({ projectName: "", budgets: [] });
            setSelectedBudget({ budgetName: "", timecodes: [] });
            setSelectedTimecode({ taskName: "" });
            
            try {
                var instance = disableExistingTimecodes(
                await getClientProjectTimecodeForUser(currentWeekStart),
                props.existingData,
                currentWeekStart
                );
                setData(instance);
            } catch {
                showErrorToast(dispatchToast, "Failed to get timecodes");
            }
            
            endLoad();
        } catch (ex) {
            console.error(ex);
            endLoad();
        }
        setOpen(true);
    };

    const AddTimecode = () => {
        const existingTimecode = props.existingData
            .find(c => c.clientId === selectedClient.clientId)
            ?.projects.find(p => p.projectId === selectedProject.projectId)
            ?.budgets.find(b => b.budgetId === selectedBudget.budgetId)
            ?.timecodes.find(t => t.taskId === selectedTimecode.taskId);

        props.handleTimecodeAdd(
            currentWeekStart,
            {clientId :selectedClient.clientId, clientName: selectedClient.clientName},
            {projectId: selectedProject.projectId, projectName: selectedProject.projectName, projectStartDate: selectedProject.projectStart, projectEndDate: selectedProject.projectEnd},
            {budgetId: selectedBudget.budgetId, budgetName: selectedBudget.budgetName},
            {taskId: selectedTimecode.taskId, taskName:selectedTimecode.taskName, taskStartDate: selectedTimecode.taskStart, taskEndDate: selectedTimecode.taskEnd},
            {userStartDate: selectedTimecode.userMapping.userStart, userEndDate: selectedTimecode.userMapping.userEnd},
            existingTimecode
        );
        setOpen(false);
    };

    
    const handleClientSelect=(item,selection) =>{
        var projects = data.filter(d=> d.clientId===selection.optionValue);
        
        setSelectedClient({clientId:selection.optionValue, 
            clientName:selection.optionText, 
            projects:projects});  
        cascadeSelection(projects,null, null);
    };

    const cascadeSelection=(projects, budgets , timecodes) => {
        if(projects!== null){            
            if(projects.length===1){             
                budgets = data.filter(d=> d.projectId === projects[0].projectId);
                setSelectedProject({projectId:projects[0].projectId, 
                    projectName:projects[0].projectName, 
                    budgets: budgets});    
            }   
            else setSelectedProject({projectName:"", budgets:[]});
        }       

        if(budgets!==null){            
            if(budgets.length===1){
                timecodes = data.filter(d=> d.budgetId === budgets[0].budgetId);    
                setSelectedBudget({budgetId:budgets[0].budgetId, 
                    budgetName:budgets[0].budgetName, 
                    timecodes:timecodes});           
            }
            else setSelectedBudget({ budgetName: "", timecodes:[]});
        }
        else if (timecodes==null) setSelectedBudget({ budgetName: "", timecodes:[]});
        
        if(timecodes!==null){
            var eligible = timecodes.filter(t=> t.isDisabled !== true);
            
            if(eligible.length===1)setSelectedTimecode(eligible[0]);
            else setSelectedTimecode({taskName:""});
        }
        else setSelectedTimecode({taskName:""});
    }

    const handleProjectSelect=(item,selection) =>{
        var budgets = data.filter(d=> d.projectId === selection.optionValue);
        setSelectedProject({projectId:selection.optionValue, 
            projectName:selection.optionText, 
            budgets: budgets});             
        cascadeSelection(null,budgets, null);
     };

     const handleBudgetSelect=(item,selection) =>{
        var timecodes= data.filter(d=> d.budgetId === selection.optionValue);
        setSelectedBudget({budgetId:selection.optionValue, 
            budgetName:selection.optionText, 
            timecodes:timecodes});    
        cascadeSelection(null,null, timecodes);
     };

     const handleTimecodeSelect=(item,selection) =>{
        var selectedTimecodeInfo = selectedBudget.timecodes.filter(timecode=> timecode.taskId === selection.optionValue)[0]
        setSelectedTimecode(selectedTimecodeInfo);        
     };    

    return (
        <>                           
            <Dialog open={open} onOpenChange={(e, { open }) => setOpen(open)}>
            <TooltipWatcherWidget text="Click to find and add timecodes" direction="after-top">
            <Button className={styles.buttonPrimary} onClick={openAddTimecode} disabled={isAddTimecodeDisabled} style={{marginBottom: '1rem'}}>Add Timecode</Button>
            </TooltipWatcherWidget>
                <DialogSurface>
                    <DialogBody>
                    <DialogTitle style={{paddingBottom: '0.5rem'}}>{data.length !== 0 ? (<>Add Timecode</>) : (< >No Available Timecodes!!</>)}</DialogTitle>
                    <DialogContent>
                        <div className='timecode-dialog'>    
                            <div>
                                <div className='timecode-col timecode-col-left'>
                                    <Subtitle2>Client</Subtitle2>
                                </div>
                                <div className='timecode-col timecode-col-right'>
                                    <Combobox          
                                        className="timecode-combobox"             
                                        onOptionSelect={handleClientSelect}
                                        value ={selectedClient.clientName}
                                        placeholder="Select client">
                                        {[...new Map(data?.map((resource) => [resource.clientName, resource])).values()]
                                        .map((resource) => (
                                            <Option key={resource.clientId} value={resource.clientId}>
                                                {resource.clientName}
                                            </Option>
                                        ))}
                                    </Combobox> 
                                </div>
                            </div>  
                            <div>
                                <div className='timecode-col timecode-col-left'>
                                    <Subtitle2>Project</Subtitle2>
                                </div>                            
                                <div className='timecode-col timecode-col-right'>
                                    <Combobox 
                                        className="timecode-combobox"    
                                        onOptionSelect={handleProjectSelect}
                                        value={selectedProject.projectName}
                                        placeholder="Select project">
                                        {[...new Map(selectedClient.projects.map((project) => [project.projectName, project])).values()]
                                        .map((project) => 
                                        (
                                            <Option key={project.projectId} value={project.projectId}>
                                            {project.projectName}
                                            </Option>
                                        )
                                        )}
                                    </Combobox>
                                </div>
                            </div>  
                            <div>        
                                <div className='timecode-col timecode-col-left'>
                                    <Subtitle2>Budget</Subtitle2>
                                </div>                            
                                <div className='timecode-col timecode-col-right'>
                                    <Combobox 
                                        className="timecode-combobox"    
                                        onOptionSelect={handleBudgetSelect}
                                        value={selectedBudget.budgetName}
                                        placeholder="Select budget">
                                        {[...new Map(selectedProject.budgets.map((budget) => [budget.budgetName, budget])).values()]
                                        .map((budget) => (
                                            <Option key={budget.budgetId} value={budget.budgetId}>
                                            {budget.budgetName}
                                            </Option>
                                        ))}
                                    </Combobox>
                                </div>
                            </div>  
                            <div>        
                                <div className='timecode-col timecode-col-left'>
                                    <Subtitle2>Timecode</Subtitle2>
                                </div>
                                <div className='timecode-col timecode-col-right'>
                                    <Combobox
                                        className="timecode-combobox"    
                                        onOptionSelect={handleTimecodeSelect}
                                        value={selectedTimecode.taskName}
                                        placeholder="Select timecode">
                                        
                                        {[...new Map(selectedBudget.timecodes.map(timecode => [timecode.taskName, timecode])).values()]
                                        .map(timecode => (
                                            <Option 
                                            key={timecode.taskId} 
                                            value={timecode.taskId}
                                            disabled={timecode.isDisabled}>
                                            {timecode.taskName}
                                            </Option>
                                        ))
                                        }
                                    </Combobox>
                                </div>                                
                            </div>
                        </div>                         
                    </DialogContent>
                    <DialogActions style={{paddingTop: '0.5rem'}}>
                    <Button appearance="secondary" onClick={() => setOpen(false)}>Cancel</Button>
                        <Button className={styles.buttonPrimary}
                            onClick={() => AddTimecode()}
                            disabled={
                                selectedClient.clientId===undefined || selectedProject.projectId===undefined || selectedTimecode.taskId===undefined || selectedBudget.budgetId===undefined
                            }>Add</Button>
                    </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>          
        </>       
    );
}